<template>
    <div i='crumbs' class="w" :class="{'sty': isCoolart}" v-if="crumbs.length > 0 || $store.state.app.crumbs.length > 0">
        <template v-if="isCoolart">
            <template v-if="crumbs.length > 0">
                <span class="crumbs-box">
                    <span class="crumbs-item">
                        <span class="crumbs-item-inner pointer" @click="toUrl('/coolart/index')">艺库</span>
                        <span class="crumbs-item-separator"><img class="img" src="/static/images/crumbs.png" ></span>
                    </span>
                    <span class="crumbs-item" v-for="(d, index) in crumbs" :key="index">
                        <span class="crumbs-item-inner" v-if="d.url" :class="{'pointer': d.url}" @click="toUrl(d.url, d.query)" v-html="d.name"></span>
                        <span class="crumbs-item-inner" v-else :class="{'pointer': d.url}" v-html="d.name"></span>
                        <span class="crumbs-item-separator"><img class="img" src="/static/images/crumbs.png" ></span>
                    </span>
                </span>
                
            </template>
            <template v-if="crumbs.length === 0 && $store.state.app.crumbs.length > 0">
                <span class="crumbs-box">
                    <span class="crumbs-item">
                        <span class="crumbs-item-inner pointer" @click="toUrl('/coolart/index')">艺库</span>
                        <span class="crumbs-item-separator"><img class="img" src="/static/images/crumbs.png" ></span>
                    </span>
                    <span class="crumbs-item" v-for="(d, index) in $store.state.app.crumbs" :key="index">
                        <span class="crumbs-item-inner" v-if="d.url" :class="{'pointer': d.url}" @click="toUrl(d.url, d.query)" v-html="d.name"></span>
                        <span class="crumbs-item-inner" v-else :class="{'pointer': d.url}" v-html="d.name"></span>
                        <span class="crumbs-item-separator"><img class="img" src="/static/images/crumbs.png" ></span>
                    </span>
                </span>
            </template>
        </template>
        <template v-else>
            <template v-if="crumbs.length > 0">
                <span class="crumbs-item">
                    <span class="crumbs-item-inner pointer" @click="toUrl('/')">首页</span>
                    <span class="crumbs-item-separator"><img class="img" src="/static/images/crumbs.png" ></span>
                </span>
                <span class="crumbs-item" v-for="(d, index) in crumbs" :key="index">
                    <span class="crumbs-item-inner" v-if="d.url" :class="{'pointer': d.url}" @click="toUrl(d.url, d.query)" v-html="d.name"></span>
                    <span class="crumbs-item-inner" v-else :class="{'pointer': d.url}" v-html="d.name"></span>
                    <span class="crumbs-item-separator"><img class="img" src="/static/images/crumbs.png" ></span>
                </span>
            </template>
            <template v-if="crumbs.length === 0 && $store.state.app.crumbs.length > 0">
                <span class="crumbs-item">
                    <span class="crumbs-item-inner pointer" @click="toUrl('/')">首页</span>
                    <span class="crumbs-item-separator"><img class="img" src="/static/images/crumbs.png" ></span>
                </span>
                <span class="crumbs-item" v-for="(d, index) in $store.state.app.crumbs" :key="index">
                    <span class="crumbs-item-inner" v-if="d.url" :class="{'pointer': d.url}" @click="toUrl(d.url, d.query)" v-html="d.name"></span>
                    <span class="crumbs-item-inner" v-else :class="{'pointer': d.url}" v-html="d.name"></span>
                    <span class="crumbs-item-separator"><img class="img" src="/static/images/crumbs.png" ></span>
                </span>
            </template>
        </template>
    </div>
</template>
<style rel='stylesheet/scss' lang='scss' scoped>
    @import '../assets/sass/common/tool';

    [i="crumbs"]{
    	width:1000px;
        height: 60px;
        line-height: 60px;

        &.sty{
            height: auto;
            line-height: 1;
            margin-top: 22px;
            margin-bottom: 22px;

            .crumbs-box{
                display: inline-block;
                height: 44px;
                background: #FFFFFF;
                box-shadow: 3px 1px 16px -3px rgba(221,221,221,0.50);
                line-height: 44px;
                padding: 0 30px;

                .crumbs-item-inner{
                    font-size: 12px;
                    color: #050E18;
                }

                .crumbs-item-separator{

                    .img{
                        position: relative;
                        top: -1px;
                        width: 8px;
                        height: 7px;
                    }
                    
                }
            }

        }

        

        .crumbs-item{

            &:last-child {
                .crumbs-item-inner{
                    color: #aaaaaa;
                }
                .crumbs-item-separator{
                    display: none;
                }
            }
            
            .crumbs-item-inner.pointer:hover{
                opacity: 0.8;
            }

            .crumbs-item-separator{
                padding: 0 8px;

                .img{
                    position: relative;
                    top: -2px;
                    width: 5px;
                    height: 9px;
                }
            }
        }
    }
</style>
<script>
    export default{
        data(){
            return {
                
            }
        },
        props: {
            crumbs: {
                type: Array,
                default: ()=>{
                	return []
                }
            },
            isCoolart: {   // 是否为ip艺库
				type: Boolean,
				default: false
			}
        },
        methods:{
            
        },
        watch: {

        },
        components:{

        },
        filters: {

        },
        mounted(){

        },
        destroyed(){

        }
    }
</script>


// WEBPACK FOOTER //
// Crumbs.vue?e5634704